import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import RelationshipLinkButtons from 'Components/ComponentLibrary/Organisms/RelationshipLinkButtons';
import { SubmitButton } from '@facet-wealth/design';
import DevResourceViewer from 'Components/ComponentLibrary/Organisms/DevResourceViewer';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
  },
  fields: {
    maxWidth: theme.dimensions.lg,
    width: '100%',
  },
  actions: {
    maxWidth: theme.dimensions.md,
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(1)}px`,
  },
});

const Content = ({
  className,
  classes,
}) => {
  const { setPageContentCollection } = usePageContentContext();
  const { resource, onSubmit } = useMetaLayoutContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <DevResourceViewer
        resource={resource}
        onRelationshipClick={async (rel) => {
          const collection = await rel.getRelated();
          await setPageContentCollection(collection);
        }}
      />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <Box className={classes.actions}>
        <RelationshipLinkButtons
          onClick={async (rel) => {
            const collection = await rel.getRelated();
            await setPageContentCollection(collection);
          }}
          resource={resource}
        />
        <SubmitButton
          isFullWidth
          onClick={async () => {
            const updatedColl = await onSubmit();
            await setPageContentCollection(updatedColl);
          }}
          label={'Submit'}
        />
      </Box>
    </Box>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
